import MobileFilterSheet from "../../ui/MobileFilterSheet";
import { formatarData } from "../../../components/utils/functions";

function SheetDetailRow({ label, value }) {
  return (
    <div className="flex justify-between gap-4 py-1 text-sm">
      <span className="text-laranjinha/60">{label}</span>
      <span className="text-right font-medium text-laranjinha">{value ?? "-"}</span>
    </div>
  );
}

function formatTransactionValue(finalPrice) {
  if (finalPrice == null || finalPrice === "") {
    return "-";
  }
  return `R$${(finalPrice / 100).toFixed(2).replace(".", ",")}`;
}

export function MobileTransactionDetailSheet({ open, onClose, transaction }) {
  if (!transaction) {
    return null;
  }

  const createdAt = transaction.createdAt
    ? formatarData(new Date(transaction.createdAt))
    : "-";

  return (
    <MobileFilterSheet open={open} onClose={onClose} title="Detalhe da transação">
      <div className="space-y-4">
        <div className="rounded-lg border border-primary/30 p-3">
          <SheetDetailRow label="ID" value={transaction._id} />
          <SheetDetailRow label="ID produto" value={transaction.product?._id} />
          <SheetDetailRow label="ID Pagamento (Getnet)" value={transaction.data?.payment_id} />
          <SheetDetailRow label="Usuário" value={transaction.user?.email} />
          <SheetDetailRow
            label="Valor"
            value={formatTransactionValue(transaction.product?.finalPrice)}
          />
          <SheetDetailRow label="Modalidade" value={transaction.kind} />
          <SheetDetailRow label="Status" value={transaction.data?.status} />
          <SheetDetailRow label="Transação criada em" value={createdAt} />
        </div>

        <button
          type="button"
          onClick={onClose}
          className="inline-flex min-h-[44px] w-full items-center justify-center rounded-lg bg-red-700 px-4 font-medium text-white hover:bg-red-800"
        >
          Fechar
        </button>
      </div>
    </MobileFilterSheet>
  );
}
